export default "__VITE_ASSET__Rt_gLr5q__"